const radii = {
  none: 0,
  sm: 2,
  md: 4,
  lg: 6,
  xl: 8,
  pill: 25,
  full: 9999,
};

export type IRadii = typeof radii;

export default radii;
